import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-333e90e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "公司名称：武汉本家团饭科技有限公司"),
  /*#__PURE__*/_createElementVNode("div", null, "公司电话：027-85718906 工作时间：9:00-18:00"),
  /*#__PURE__*/_createElementVNode("div", null, "公司地址：湖北省武汉市江岸区解放大道融创融汇广场"),
  /*#__PURE__*/_createElementVNode("div", { class: "bj-flex-start" }, [
    /*#__PURE__*/_createElementVNode("div", null, "© 2020-2025 版权所有"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://beian.miit.gov.cn/",
      target: "_blank",
      style: {"color":"#fe8c29"}
    }, "鄂ICP备20007428号-1")
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}